import * as React from "react";
import PropTypes from "prop-types";
import TableCell from "@mui/material/TableCell";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";


export default function ExternalLinkCell({ href, label = "Link" }) {
  const safeHref =
    href && (href.startsWith("http") ? href : `https://${href}`);

  return (
    <TableCell>
      <a
        className="link"
        href={safeHref}
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {label}
        <OpenInNewIcon
          sx={{
            fontSize: "1rem",
            marginLeft: "0.3rem",
          }}
        />
      </a>
    </TableCell>
  );
}

ExternalLinkCell.propTypes = {
  href: PropTypes.string,
  label: PropTypes.string,
};
